module.exports = __webpack_public_path__ + "static/bg-video-fa465ba76b178a9c4f99587513757d58.mp4";